"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _CardActionArea = _interopRequireDefault(require("@material-ui/core/CardActionArea"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    avatar: {
      backgroundColor: theme.palette.primary.main
    },
    media: {
      paddingTop: '50%'
    }
  };
});

var ProductCard = function ProductCard(_ref) {
  var coverSrc = _ref.coverSrc,
      title = _ref.title,
      subheader = _ref.subheader,
      nbCertificates = _ref.nbCertificates,
      onOpen = _ref.onOpen,
      noAvatar = _ref.noAvatar;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    className: (0, _classnames["default"])(classes.root)
  }, /*#__PURE__*/_react["default"].createElement(_CardActionArea["default"], {
    onClick: onOpen
  }, coverSrc ? /*#__PURE__*/_react["default"].createElement(_CardMedia["default"], {
    className: classes.media,
    image: coverSrc,
    title: title
  }) : '', /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], _extends({}, !noAvatar ? {
    avatar: /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      "aria-label": "Recipe",
      className: classes.avatar
    }, nbCertificates > 99 ? '99+' : 1 * nbCertificates)
  } : {}, {
    title: title,
    subheader: subheader
  }))));
};

ProductCard.propTypes = {
  className: _propTypes["default"].string,
  coverSrc: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  subheader: _propTypes["default"].string.isRequired,
  nbCertificates: _propTypes["default"].number.isRequired
};
ProductCard.defaultProps = {
  className: ''
};
var _default = ProductCard;
exports["default"] = _default;